import { z } from 'zod';

enum DiscountType {
  PERCENTAGE = 'PERCENTAGE',
  CASH = 'CASH',
}

const promoRewardSchema = z
  .object({
    discountType: z.nativeEnum(DiscountType, {
      errorMap: () => ({
        message: '*Select one of the type',
      }),
    }),
    amount: z.coerce.number(),
    maxDiscount: z.coerce.number().optional(),
  })
  .superRefine(({ discountType, amount, maxDiscount }, ctx) => {
    if (discountType === DiscountType.CASH && amount < 1) {
      ctx.addIssue({
        path: ['amount'],
        code: 'custom',
        message: '*Cash amount should be greater than 1',
      });
    }

    if (discountType === DiscountType.PERCENTAGE && (amount < 1 || amount > 100)) {
      ctx.addIssue({
        path: ['amount'],
        code: 'custom',
        message: '*Discount percentage should be between 1 - 100%',
      });
    }

    if (maxDiscount && maxDiscount < 1) {
      ctx.addIssue({
        path: ['maxDiscount'],
        code: 'custom',
        message: '*Max Discount Amount must greater than 0',
      });
    }
  });

type PromoRewardSchemaType = z.infer<typeof promoRewardSchema>;

export type { PromoRewardSchemaType };

export { DiscountType, promoRewardSchema };
